var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 76,
    viewBox: "0 0 38 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5292 73.367C19.7327 74.5004 18.053 74.5004 17.2565 73.367L5.14821 56.1368C4.21694 54.8116 5.16486 52.9869 6.78458 52.9869L31.0011 52.9869C32.6208 52.9869 33.5688 54.8116 32.6375 56.1368L20.5292 73.367Z",
    fill: "#91BD31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5292 58.2281C19.7327 59.3615 18.053 59.3615 17.2565 58.2281L5.14821 40.9979C4.21694 39.6727 5.16486 37.8479 6.78458 37.8479L31.0011 37.8479C32.6208 37.8479 33.5688 39.6727 32.6375 40.9979L20.5292 58.2281Z",
    fill: "#B1D55A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5292 41.8272C19.7327 42.9606 18.053 42.9606 17.2565 41.8272L5.14821 24.597C4.21694 23.2718 5.16486 21.4471 6.78458 21.4471L31.0011 21.4471C32.6208 21.4471 33.5688 23.2718 32.6375 24.597L20.5292 41.8272Z",
    fill: "#D1E4A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5292 27.9498C19.7327 29.0832 18.053 29.0832 17.2565 27.9498L5.14821 10.7196C4.21694 9.39433 5.16486 7.56963 6.78458 7.56963L31.0011 7.56963C32.6208 7.56963 33.5688 9.39434 32.6375 10.7196L20.5292 27.9498Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow_down.6bd405490782e20f6f55ca809d858bf2.svg";